import Navigation from "@/components/landing/Navigation";
import Footer from "@/components/landing/Footer";

const MentalHealth = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-100 to-neutral-50 relative overflow-hidden">
      {/* Flowing background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-[60%] bg-gradient-to-bl from-secondary/15 via-secondary/8 to-transparent blur-3xl" />
      <div className="absolute top-1/4 left-0 w-1/3 h-[50%] bg-gradient-to-r from-accent-teal/12 via-accent-teal/6 to-transparent blur-2xl" />
      <div className="absolute bottom-0 right-1/4 w-1/2 h-[40%] bg-gradient-to-t from-secondary/10 via-transparent to-transparent blur-3xl" />
      
      <Navigation />
      <main className="pt-32 pb-16 relative z-10">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6">
              Mental Health Services
            </h1>
            <p className="text-xl text-neutral-600 mb-8">
              Comprehensive digital mental health solutions providing accessible, evidence-based psychological support and therapy services.
            </p>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Digital Mental Health Platform</h2>
              <p className="text-neutral-600 mb-6">
                Our mental health services combine licensed therapists, AI-powered assessments, and evidence-based therapeutic interventions to provide comprehensive mental health support accessible from anywhere.
              </p>
              
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Services Available</h2>
              <ul className="list-disc list-inside text-neutral-600 space-y-2 mb-6">
                <li>Individual therapy sessions with licensed professionals</li>
                <li>Group therapy and support groups</li>
                <li>Cognitive behavioral therapy (CBT) programs</li>
                <li>Mental health assessments and screening</li>
                <li>Crisis intervention and support</li>
                <li>Mindfulness and stress reduction programs</li>
              </ul>
              
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Personalized Care</h2>
              <p className="text-neutral-600">
                Every individual's mental health journey is unique. Our platform provides personalized treatment plans, continuous progress monitoring, and adaptive interventions to ensure the most effective care for each person's specific needs.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentalHealth;